// import { Dialog } from '@mui/material';
import { Modal, ModalBody } from "reactstrap";
import React from 'react';
import { ReactComponent as CrossIcon } from "../../../../../../../assets/img/svg/CrossIcon.svg";
import { paymentMode } from "../components/constant";
import ALoader from "../../../../common/a-loader";



const EditPaymentDetailsDialog = ({ 
    open,
    setOpen,
    crossClickHandler,
    contextValue,
    currentPaymentMode,
    paymentModeName,
    loader
}) => {

    const SelectedPaymentMode = paymentMode?.[currentPaymentMode];

    const handleClose = () => setOpen(false);

    return (
        <Modal
            isOpen={open}
            style={{ maxWidth: '900px', width: '100%' }}
            size="xl"
            className="select-payment-mode"
        >
            <ModalBody className='p-4'>
                <div className='d-flex justify-content-between'>
                    <h2>{paymentModeName} Details</h2>
                    <CrossIcon onClick={crossClickHandler} />
                </div>
                {loader && <ALoader/>}
                {
                        <SelectedPaymentMode contextValue={contextValue} isReceiptEdit='fromCollection' handleClose={handleClose} />
                }

            </ModalBody>
        </Modal>
    );
}

export default EditPaymentDetailsDialog;